import { cn } from "@/utils/classes";
import NoProjects from "@/assets/fallbacks/no-projects.svg";
import NoStudies from "@/assets/fallbacks/no-studies.svg";

/* Prop types */
interface EmptyStateProps {
  title: string;
  className?: string;
  isProjectEmpty?: boolean;
}

/*
 * EmptyState component
 */
export const EmptyState = ({ title, className, isProjectEmpty }: EmptyStateProps) => {
  /* Render */
  return (
    <div className={cn("flex flex-col items-center justify-center gap-4 py-4", className)}>
      <h2 className="text-base-content/70">{title}</h2>
      {isProjectEmpty ? <img src={NoProjects} /> : <img src={NoStudies} />}
    </div>
  );
};
